import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  standalone: false,
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.scss']
})
export class DeleteModalComponent implements OnInit {
  @Input() title: string = '';
  /** Sustituye el texto por defecto ("¿Estás seguro de que quieres eliminar el {title}?"). */
  @Input() message?: string;
  /** Si se indica, hay que escribir este texto exacto para poder confirmar (borrados de más riesgo). */
  @Input() confirmName?: string;
  /** Título de la cabecera. Por defecto "Confirmar borrado" (útil para reutilizar este modal en confirmaciones que no son un borrado). */
  @Input() modalTitle = 'Confirmar borrado';
  /** Texto del botón de confirmar. Por defecto "Eliminar". */
  @Input() confirmLabel = 'Eliminar';
  /** Color del botón Cancelar (material). Por defecto "primary". */
  @Input() cancelColor = 'primary';
  /** Color del botón de confirmar (material). Por defecto "warn". */
  @Input() confirmColor = 'warn';
  /** Tercer botón opcional (p.ej. "Guardar y salir"); si no se indica, no aparece.
   *  Se resuelve con el string 'third' en vez de true/false para poder distinguirlo. */
  @Input() thirdLabel?: string;
  /** Color del tercer botón (material). Por defecto "primary". */
  @Input() thirdColor = 'primary';
  /** Oculta el botón de texto "Cancelar" y muestra en su lugar una X para cerrar
   *  en la esquina (mismo efecto, cancel()). Por defecto false: no cambia los
   *  demas usos de este modal. */
  @Input() hideCancelButton = false;
  confirmInput = '';

  constructor(private modalController: ModalController) { }

  ngOnInit(): void { }

  get canConfirm(): boolean {
    return !this.confirmName || this.confirmInput.trim() === this.confirmName.trim();
  }

  cancel() {
    this.modalController.dismiss(false);
  }

  confirm() {
    if (!this.canConfirm) return;
    this.modalController.dismiss(true);
  }

  confirmThird() {
    this.modalController.dismiss('third');
  }
}
